export default "__VITE_ASSET__2f567077__"